const fetch = require('node-fetch');

const requestOptions = {
  method: 'GET',
  redirect: 'follow',
};

global.slack = {
  log: (message = '', title = 'New Message', channel) => {
    try {
      fetch(`https://procuzy-helpers.azurewebsites.net/slack/send_message?type=info&character=MAC&channel=${channel}&title=${title}&message=${message}`, requestOptions);
    } catch (err) {
      console.log(err);
    }
  },
};
